module.exports = __webpack_public_path__ + "static/media/importICloud4.a4ab92e5.png";